/**
 * The three names the page and the service worker both have to know (021 FR-011, FR-018, FR-032).
 *
 * A worker and the document it serves are separate bundles that cannot share an import at run time,
 * so every one of these is spelled twice at run time whatever this file does. What it buys is that
 * they are spelled once in the SOURCE — `src/sw.ts` and `update.store.ts` import the same constant,
 * and a typo in either half becomes a compile error rather than a message nobody answers.
 *
 * That is this repository's standing rule about a second definition, and here it has teeth: a
 * mistyped `SKIP_WAITING` produces an update offer whose button does nothing at all, and a mistyped
 * cache prefix produces an unrecoverable-recovery that sweeps no caches — both silent, and both
 * only reachable through a real deploy.
 */

/**
 * The prefix every cache this application owns is named with.
 *
 * FR-018's recovery deletes the worker's stored copy, and it must delete ONLY this application's
 * caches — a bystander on the same origin is not ours to clear. Angular's worker named its caches
 * `ngsw:<n>:…`, which is what `update.store.ts` used to filter on; Workbox names its precache
 * `<prefix>-precache-<version>-<scope>` and takes the prefix from `setCacheNameDetails`, so
 * `src/sw.ts` sets it from here and the sweep matches on it.
 */
export const CACHE_PREFIX = 'completeme';

/** Page → worker: stop waiting and take over. What the update offer's button ultimately sends. */
export const SKIP_WAITING = 'completeme/skip-waiting';

/**
 * Worker → page: the stored copy is broken beyond the worker's own repair (FR-018).
 *
 * Angular's `SwUpdate` published this as an `unrecoverable` observable, computed inside a worker
 * this repository did not write. Workbox has no such event, so `src/sw.ts` raises it itself, at the
 * one place the condition is observable: a navigation whose precached shell cannot be produced.
 */
export const UNRECOVERABLE = 'completeme/unrecoverable';
